import React from 'react';

import { Box } from '@opendoor/atoms/box';
import { IconChevronLeft } from '@tabler/icons-react';

interface MobileSubMenuBackButtonProps {
  onClick: () => void;
}

export const MobileSubMenuBackButton: React.FC<MobileSubMenuBackButtonProps> = ({ onClick }) => {
  return (
    <Box
      onClick={onClick}
      aria-label="Back"
      className="cursor-pointer appearance-none border-0 bg-transparent pt-4 pb-3 pl-6 pr-4 text-od-content-primary"
    >
      <IconChevronLeft size={24} aria-hidden="true" />
    </Box>
  );
};
